import { selectableNetworks } from '@polkadot/networks';
import { objectSpread } from '@polkadot/util';
export const chains = /*#__PURE__*/selectableNetworks.filter(n => n.genesisHash.length).reduce((chains, _ref) => {
  let {
    genesisHash,
    network
  } = _ref;
  return objectSpread(chains, {
    [network]: genesisHash
  });
}, {});